import { useQuery } from 'react-query';
import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { Paginated } from 'mdello-client-ts/dist/src/interfaces/common/paging.interface';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getOrdersPaginated } from 'src/services/napi/orders/fetchOrders';
import { OrderGroupDetailed } from './interfaces/orderGroup.interface';

const fetchOrders = async (params: {
  itemId?: string;
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
}): Promise<{ data: OrderGroupDetailed[]; paging: Paginated } | undefined> => {
  const { sortBy, page, pageSize, search, sortOrder } = params;

  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );

  if (!currentProject) return;

  const item = params.itemId === 'ALL' ? '' : params.itemId;

  const data: any | undefined = await getOrdersPaginated({
    itemId: item,
    page: page || '1',
    pageSize: pageSize || '10',
    projectId: currentProject._id,
    search: search || '',
    sortBy: sortBy || 'createdAt',
    sortOrder: sortOrder || '-1'
  });

  if (!data) return;

  return { data: data.data, paging: data.paging };
};

export const useGetOrders = (params: {
  itemId?: string;
  page?: string;
  pageSize?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
}) => {
  const { notify } = useNotification();
  const { sortBy, page, pageSize, search, sortOrder, itemId } = params;

  return useQuery(
    [QueryKey.ORDERS, page, pageSize, sortBy, search, sortOrder, itemId],
    () =>
      fetchOrders({
        itemId,
        page,
        pageSize,
        search,
        sortBy,
        sortOrder
      }),
    {
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
